import React from 'react'
import { Gramm, Microorganism, Cuantity_Number, Cuantity_Text, ResistanceMechanism, Comments, unReleaseBacter } from '../../../constant/globalContantsMicro';
import { Col, Input, Row, Button } from 'reactstrap'
import Select from 'react-select';
import { ToolTips } from '../../../components/tooltips/ToolTips';
import UserValidate from '../../../assets/images/loginHelenLabs/Dicount/UserDiscount2.svg'
import { Both, Other, Actibiogram, Isolated, placeholder_stain_gram, placeholder_bacterium, placeholder_count_text, placeholder_mechanisms, validateBacter, unValidateBacter, unReleaseteBacter, LabelSelectionMicro, LabelSelectionAntibiogram, Labelmedicamen, LabelInterpretation, LabelCm, LabelCmSemlab, LabelAntibitic, placeholder_anti, ReleaseteBacter } from '../../../constant/globalContantsMicro';
import { semlab } from '../../../constant/globalConstantsTypeClients';


export const ComponentMicroorganismIsolated = ({ idExam, microBacteriums, handleChangeBacter, listStainGrams, listOptionsBacteriums, handleGram, listBacteriumCount, listResistanceMechanism, colorBacter, warningBacter, handleTypeBacterium, microAntibiograms, changeMicro, listAntibiogram, handleChange, antibitic, handleChangeAntibiogram, handleChangeComments, handleChangeBacteriumTexts, removeBacterium1, removeBacteriumAntibitic, ValidateBacterium, examId, is_profile, sectionProfileId, typeArray, UnValidateBacterium, ReleaseBacterium, UnReleaseBacterium, _typeClient, cedimi, handleCreateGlobalComment, handleFullUnvalidate }) => {
    console.log("🚀 ~ ComponentMicroorganismIsolated ~ listAntibiogram:", listAntibiogram)
    console.log("🚀 ~ gatosted ~ idExam:", idExam)
    console.log("🚀 ~ gatos~ microBacteriums:", microBacteriums)
    console.log("🚀 ~ gatos:", microBacteriums?.id_mic_antibiogram);
    console.log("🚀 ~ gatos:", microBacteriums?.id_mic_antibiogram);

    let url_helen = localStorage.getItem('url_helen');


    return (
        <>
            <Col sm="12" className='p-r-0' >
                {microBacteriums?.id_work_order_exam === idExam && (

                    <div style={{ boxShadow: "0 0 40px rgba(8, 21, 66, 0.05)" }} key={`id_mic-${microBacteriums?.id_temp}`}>
                        <div style={{ borderTop: "4px dotted #28a745", padding: "10px", backgroundColor: "transparent" }}></div>

                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 15px",
                            borderRadius: "10px",
                            background: "#f8fafc"
                        }}>

                            <h5 style={{ margin: 0, fontWeight: "600" }}>
                                {Isolated}
                            </h5>

                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px"
                            }}>

                                {/* USUARIO */}
                                {
                                    (microBacteriums?.validated_at !== "" && microBacteriums?.released_at === "") &&
                                    <>
                                        <img id={"tooltip-bacterium-" + microBacteriums?.id_temp}
                                            style={{
                                                cursor: "pointer",
                                                width: "35px",
                                                borderRadius: "50%",
                                                border: "2px solid #28a745",
                                            }}
                                            className=" mr-1 rounded-circle" src={UserValidate} alt="" />
                                        <ToolTips
                                            dataPlacement='top'
                                            dataTarget={"tooltip-bacterium-" + microBacteriums?.id_temp}
                                            dataText={"-" + microBacteriums?.validated_at + "-" + "Capturado por:" + microBacteriums?.validated_by}
                                        />
                                    </>
                                }
                                {
                                    (microBacteriums?.validated_at !== "" && microBacteriums?.released_at !== "") &&
                                    <>
                                        <img id={"tooltip-bacterium-release-" + microBacteriums?.id_temp}
                                            style={{
                                                cursor: "pointer",
                                                width: "35px",
                                                borderRadius: "50%",
                                                border: "2px solid #28a745",
                                            }}
                                            className=" mr-1 rounded-circle" src={UserValidate} alt="" />
                                        <ToolTips
                                            dataPlacement='top'
                                            dataTarget={"tooltip-bacterium-release-" + microBacteriums?.id_temp}
                                            dataText={"-" + microBacteriums?.released_at + "-" + "Capturado por:" + microBacteriums?.released_by}
                                        />
                                    </>
                                }

                                {/* DELETE */}
                                {
                                    microBacteriums?.validated_at === "" &&
                                    <i
                                        className="fa fa-trash"
                                        style={{
                                            color: "#dc3545",
                                            cursor: "pointer",
                                            fontSize: "30px"
                                        }}
                                        title='Eliminar Microorganismos '
                                        onClick={() => removeBacterium1(idExam, microBacteriums?.id_temp, microBacteriums?.id_mic_bacterium)}
                                    ></i>
                                }

                                {/* VALIDATE */}
                                {
                                    microBacteriums?.validated_at === "" && microBacteriums?.update &&
                                    <Button
                                        size="sm"
                                        style={{
                                            borderRadius: "10px",
                                            padding: "4px 12px",
                                            fontSize: "16px"
                                        }}
                                        color="success"
                                        onClick={() => ValidateBacterium(idExam, microBacteriums?.id_temp, microBacteriums?.id_mic_bacterium, examId, is_profile, sectionProfileId, typeArray, microBacteriums?.id_mic_bacterium)}
                                    >
                                        {validateBacter}
                                    </Button>
                                }

                                {/* DESVALIDATE */}
                                {
                                    microBacteriums?.released_at === "" && microBacteriums?.validated_at !== "" &&
                                    <Button
                                        size="sm"
                                        style={{ borderRadius: "10px", padding: "4px 12px", fontSize: "16px" }}
                                        color="danger"
                                        outline
                                        onClick={() => UnValidateBacterium(idExam, microBacteriums?.id_temp, microBacteriums?.id_mic_bacterium, examId, is_profile, sectionProfileId, typeArray)}
                                    >
                                        {unValidateBacter}
                                    </Button>
                                }





                                {/* RELEASE */}
                                {
                                    microBacteriums?.released_at === "" && microBacteriums?.validated_at !== "" &&
                                    <Button
                                        size="sm"
                                        style={{ borderRadius: "10px", padding: "4px 12px", fontSize: "16px" }}
                                        color="primary"
                                        onClick={() => ReleaseBacterium(idExam, microBacteriums?.id_temp, microBacteriums?.id_mic_bacterium, examId, is_profile, sectionProfileId, typeArray, microBacteriums?.id_mic_bacterium)}
                                    >
                                        {ReleaseteBacter}
                                    </Button>
                                }


                                {
                                    microBacteriums?.released_at !== "" && microBacteriums.validated_at !== ""
                                        ?
                                        <Button
                                            size="sm"
                                            style={{ borderRadius: "10px", padding: "4px 12px", fontSize: "16px" }}
                                            color="danger"
                                            outline
                                            onClick={() => UnReleaseBacterium(idExam, microBacteriums?.id_temp, microBacteriums?.id_mic_bacterium, examId, is_profile, sectionProfileId, typeArray)}
                                        >
                                            {unReleaseBacter}
                                        </Button>
                                        : ""
                                }


                                {/* ESTADO */}
                                {
                                    microBacteriums?.released_at !== "" &&
                                    <span style={{
                                        background: "#e7f1ff",
                                        color: "#0d6efd",
                                        padding: "4px 10px",
                                        borderRadius: "15px",
                                        fontSize: "15px",
                                        fontWeight: "500"
                                    }}>
                                        {unReleaseteBacter}
                                    </span>
                                }


                                <Col className='mt-5'>

                                </Col>
                                <Col className='mt-5'>

                                </Col>
                            </div>


                        </div>

                        <Col sm="10" className='p-r-0 p-l-0' >
                            <Row>
                                <Col sm="3">
                                    <label className='txt-secondary'>{Gramm}</label>
                                    <Select
                                        isDisabled={microBacteriums?.validated_at !== "" ? true : false}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        menuPlacement={"top"}
                                        name="id_mic_stain_gram"
                                        options={listStainGrams}
                                        value={microBacteriums?.id_mic_stain_gram}
                                        styles={colorBacter}
                                        onChange={(e) => handleGram(e, microBacteriums?.id_temp, "id_mic_stain_gram", idExam, microBacteriums?.id_mic_bacterium)}
                                        placeholder={placeholder_stain_gram}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#898989',
                                            },
                                        })}

                                    />
                                </Col>
                                <Col sm="3">
                                    <label className='txt-secondary'>{Microorganism}</label>
                                    <Select
                                        isDisabled={microBacteriums?.validated_at !== "" ? true : false}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        menuPlacement={"top"}
                                        name="id_mic_bacterium"
                                        options={listOptionsBacteriums}
                                        value={microBacteriums?.id_mic_bacterium}
                                        styles={colorBacter}
                                        onChange={(e) => handleChangeBacter(e, microBacteriums?.id_temp, "id_mic_bacterium", idExam, microBacteriums?.id_mic_bacterium)}
                                        placeholder={placeholder_bacterium}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#898989',
                                            },
                                        })}

                                    />
                                </Col>
                                <Col sm="3">
                                    <label className='txt-secondary'>{Cuantity_Number}</label>
                                    <Input
                                        disabled={microBacteriums?.validated_at !== "" ? true : false}
                                        className='form-control form-control-sm input-air-primary border-success'
                                        name='quantity_number'
                                        value={microBacteriums?.quantity_number}
                                        onChange={(e) => handleChangeBacter(e, microBacteriums?.id_temp, "quantity_number", idExam, microBacteriums?.quantity_number)}
                                    />
                                </Col>
                                <Col sm="3" className='p-r-0' >
                                    <label className='txt-secondary'>{Cuantity_Text}</label>
                                    <Select
                                        isDisabled={microBacteriums?.validated_at !== "" ? true : false}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        menuPlacement={"top"}
                                        name="id_bacterium_count_text"
                                        options={listBacteriumCount}
                                        value={microBacteriums?.id_bacterium_count_text}
                                        styles={colorBacter}
                                        onChange={(e) => handleChangeBacter(e, microBacteriums?.id_temp, "id_bacterium_count_text", idExam, microBacteriums?.id_bacterium_count_text)}
                                        placeholder={placeholder_count_text}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary25: '#898989',
                                            },
                                        })}
                                        isClearable
                                    />
                                </Col>
                            </Row>
                        </Col>
                        <Row className='mt-4'>
                            <Col sm="9" className="p-r-0" >
                                <h5>{ResistanceMechanism}</h5>
                                <label className='txt-secondary'>{ResistanceMechanism}</label>
                                <Select
                                    isDisabled={microBacteriums?.validated_at !== "" ? true : false}
                                    isMulti
                                    menuPlacement={"top"}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    name="ids_resistance_mechanisms"
                                    options={listResistanceMechanism}
                                    value={microBacteriums?.ids_resistance_mechanisms}
                                    styles={colorBacter}
                                    onChange={(e) => handleChangeBacter(e, microBacteriums?.id_temp, "ids_resistance_mechanisms", idExam, microBacteriums?.ids_resistance_mechanisms)}
                                    placeholder={placeholder_mechanisms}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary25: '#898989',
                                        },
                                    })}
                                    isClearable
                                />
                            </Col>

                        </Row>
                        <Row className='mt-3'>
                            <Col sm="9" className='p-r-0' >
                                <label className='txt-secondary'>{Comments}</label>
                                <Input
                                    disabled={microBacteriums?.validated_at !== "" ? true : false}
                                    className='form-control form-control-sm input-air-primary border-success'
                                    name='comment_resistance_mechanism'
                                    value={microBacteriums?.comment_resistance_mechanism}
                                    onChange={(e) => handleChangeBacter(e, microBacteriums?.id_temp, "comment_resistance_mechanism", idExam, microBacteriums?.comment_resistance_mechanism)}
                                />
                            </Col>
                            <Col sm="2" className='mt-4'>
                                <Button
                                    outline
                                    color='success'
                                    onClick={() => handleCreateGlobalComment(
                                        3,
                                        2,
                                        microBacteriums?.id,
                                        microBacteriums
                                    )}
                                >
                                    <i className="fa fa-search-plus p-1"></i>

                                </Button>
                            </Col>

                        </Row>
                        <Row className='pt-3' style={microBacteriums?.validated_at !== "" ? { pointerEvents: "none", opacity: "0.5" } : {}}>
                            <Col sm="7" className='mt-3' >
                                <h5>{Actibiogram}</h5>
                            </Col>
                            <Col sm="1" className={_typeClient === cedimi ? "d-none" : 'p-l-0 p-r-0 mt-3'}  >
                                <i className={microBacteriums?.view2 === true ? "fa fa-square f-20 icon-a-a txt-success" : "fa fa-square-o f-20 icon-a-a txt-success"} onClick={() => handleTypeBacterium(2, microBacteriums?.id_temp, idExam, microBacteriums?.id_mic_bacterium)}  ></i>
                                <label className='txt-success'>{Other}</label>
                            </Col>
                            <Col sm="1" className='p-l-0 p-r-0 mt-3' style={{ textAlign: "end" }}>
                                <i className={microBacteriums?.view1 === true ? "fa fa-square f-20 icon-a-a txt-success" : "fa fa-square-o f-20 icon-a-a txt-success"} onClick={() => handleTypeBacterium(1, microBacteriums?.id_temp, idExam, microBacteriums?.id_mic_bacterium)}  ></i>
                                <label className='txt-success'>{Actibiogram}</label>
                            </Col>
                            <Col sm="1" className={_typeClient === cedimi ? "d-none" : 'p-l-0 p-r-0 mt-3'} style={{ textAlign: "end" }} >
                                <i className={microBacteriums?.view3 === true ? "fa fa-square f-20 icon-a-a txt-success" : "fa fa-square-o f-20 icon-a-a txt-success"} onClick={() => handleTypeBacterium(3, microBacteriums?.id_temp, idExam, microBacteriums?.id_mic_bacterium)}  ></i>
                                <label className='txt-success'>{Both}</label>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Col sm="11">
                                {
                                    (microBacteriums?.view1 || microBacteriums?.view3) && <div>
                                        <Col sm="12" className='p-l-0 p-r-0' >
                                            <Row>
                                                <Col sm="6">
                                                    <b className='txt-success'>{LabelSelectionMicro}</b> <br />
                                                    <Select
                                                        isDisabled={microBacteriums?.validated_at !== "" ? true : false}
                                                        menuPlacement={"top"}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        name="id_mic_bacteriums"
                                                        options={[microBacteriums?.id_mic_bacterium]}
                                                        value={microBacteriums?.update ? microBacteriums?.id_mic_bacterium : microAntibiograms?.id_mic_bacterium}
                                                        onChange={(e) => changeMicro(e, microBacteriums?.id_temp, idExam)}
                                                        placeholder={"Selecciona un microorganismo"}
                                                        styles={colorBacter}
                                                        theme={
                                                            (theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#898989'
                                                                }
                                                            })
                                                        }
                                                    />
                                                </Col>
                                                <Col sm="6">
                                                    <b className='txt-success'>{LabelSelectionAntibiogram}</b> <br />
                                                    <Select
                                                        // isDisabled={microBacteriums?.validated_at !== "" ? true :false}
                                                        menuPlacement={"top"}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        name="id_mic_antibiogram"
                                                        options={listAntibiogram}
                                                        value={microBacteriums?.id_mic_antibiogram}
                                                        onChange={(e) => handleChangeAntibiogram(e, microBacteriums?.id_temp, "id_mic_antibiogram", idExam, microBacteriums?.id_mic_antibiogram, "section")}
                                                        placeholder={placeholder_anti}
                                                        styles={colorBacter}
                                                        theme={
                                                            (theme) => ({
                                                                ...theme,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#898989'
                                                                }
                                                            })
                                                        }
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </div>
                                }
                                {
                                    (microBacteriums?.view3 || microBacteriums?.view1) && microBacteriums?.antibiotics.length > 0 &&
                                    <div className='pt-3 pricingtable' style={{ textAlign: "justify" }}  >
                                        <Col sm="12" className='p-l-0 p-r-0 pt-3' >
                                            <Row className='pt-3 ' >
                                                <Col sm="1" style={{ fontSize: "14px",  display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center" } }>
                                                    <b>AWARE</b>
                                                </Col>
                                                <Col sm="3" style={{ fontSize: "14px" }}>
                                                    <b>{Labelmedicamen}</b>
                                                </Col>
                                                <Col sm="2" style={{ fontSize: "14px" }}>
                                                    {url_helen === semlab ? (
                                                        <b>{LabelCmSemlab}</b>
                                                    ) : (
                                                        <b>{LabelCm}</b>
                                                    )}
                                                </Col>

                                                <Col sm="5" style={{ textAlign: "center", fontSize: "14px" }} >
                                                    <b>{LabelInterpretation}</b>
                                                </Col>
                                            </Row>
                                        </Col>
                                        {
                                            microBacteriums?.antibiotics.map((_anti, _key) => {
                                                const awareConfig = {
                                                    1: { text: "A", bg: "#e3ffb9", badge: "#4CAF50", textColor: "#fff", title: "ACCESO" },
                                                    2: { text: "W", bg: "#feff006e", badge: "#FFC107", textColor: "#000", title: "PRECAUCIÓN" },
                                                    3: { text: "R", bg: "#ff000029", badge: "#F44336", textColor: "#fff", title: "RESERVA" },
                                                    4: { text: "", bg: "", badge: "#6c757d", textColor: "#fff", title: "SIN AWARE" }
                                                };

                                                const config = awareConfig[_anti?.mic_aware] || {};

                                                const bgColor = config.bg || "";
                                                const badgeColor = config.badge || "";
                                                const textColor = config.textColor || "#fff";
                                                const textAware = config.text || "";
                                                const titleText = config.title || "";
                                                const isCedimi = url_helen === cedimi;
                                                //Cambios para hsjs
                                                return (

                                                    <Row className='pt-3 pb-3' 
                                                    // style={{ backgroundColor: bgColor, borderBottom: _typeClient === cedimi ? '1px solid #0000005e' : '1px solid #c3c3c38f' }} key={`id_antibiogram-${_key}`}>
                                                        style={{
                                                            backgroundColor: isCedimi ? "" : bgColor,
                                                            borderBottom: _typeClient === cedimi 
                                                                ? '1px solid #0000005e' 
                                                                : '1px solid #c3c3c38f'
                                                        }}>
                                                        <Col
                                                            sm="1"
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center"
                                                            }}
                                                        >
                                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                                                                {(_anti?.mic_aware !== 4 && _anti?.mic_aware != null) && (
                                                                    <div
                                                                        title={titleText}
                                                                        style={{
                                                                            width: "28px",
                                                                            height: "28px",
                                                                            borderRadius: "50%",
                                                                            backgroundColor: badgeColor,
                                                                            color: textColor,
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontSize: "12px",
                                                                            fontWeight: "bold",
                                                                            cursor: "pointer"
                                                                        }}
                                                                    >
                                                                        {textAware}
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </Col>
                                                        <Col sm="3">
                                                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                <strong>
                                                                    <label className="txt-darck mt-2">
                                                                        {_anti?.mic_antibiotic ?? "---"}
                                                                    </label>
                                                                </strong>

                                                            </div>

                                                        </Col>
                                                        <Col sm="1" className='p-l-0 ' >
                                                            <Input
                                                                disabled={microBacteriums?.validated_at !== "" ? true : false}

                                                                className={_typeClient === cedimi ? 'form-control form-control-sm input-air-primary ' : 'form-control form-control-sm input-air-primary border-success'}
                                                                type='text'
                                                                name='cim'
                                                                value={_anti?.cim}
                                                                onChange={(e) => handleChange(e, microBacteriums?.id_temp, idExam, _anti?.cim, _anti?.id_mic_antibiotic, "cim")}
                                                            />
                                                        </Col>
                                                        <Col sm="7" className='pt-2' >
                                                            <Row>
                                                                {
                                                                    antibitic.length > 0 && antibitic.map((_antibiotic, _keys) => {
                                                                        console.log("🚀 ~ antibitic.length>0&&antibitic.map ~ _antibiotic:", _antibiotic)
                                                                        const _isCheck = _antibiotic?.id_antibiotic_bacterium_result === _anti?.id_antibiotic_bacterium_result;
                                                                        console.log("🚀 ~ antibitic.length>0&&antibitic.map ~ _isCheck:", _isCheck)

                                                                        return (
                                                                            <Col sm="3" key={_keys}>
                                                                                <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", color: _isCheck ? 'green' : 'black', fontSize: "12px" }}>
                                                                                    <input
                                                                                        disabled={microBacteriums.validated_at !== "" ? true : false}
                                                                                        type="checkbox"
                                                                                        value={_antibiotic?.id_mic_antibiotic}
                                                                                        checked={_isCheck}
                                                                                        onChange={(e) => handleChange(e, microBacteriums?.id_temp, idExam, _antibiotic?.id_antibiotic_bacterium_result, _anti?.id_mic_antibiotic, "check")}
                                                                                        style={_typeClient === cedimi ? { accentColor: "#000" } : { accentColor: "green", transform: "scale(1.4)", cursor: "pointer" }}
                                                                                    />
                                                                                    {_antibiotic.name}
                                                                                </label>
                                                                            </Col>
                                                                        );
                                                                    })
                                                                }
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                );
                                            })
                                        }
                                    </div>
                                }
                                {
                                    (microBacteriums?.view3 || microBacteriums?.view2) && microBacteriums?.bacterium_texts.length > 0 &&
                                    <div className='pt-3 pricingtable pl-0 pr-0' style={{ textAlign: "justify" }}>
                                        {
                                            microBacteriums?.bacterium_texts.map((_text, _k) => {
                                                return (
                                                    <Row key={_k}  >
                                                        <Col sm="1" className='p-r-0'>
                                                            <label className='txt-secondary'>{LabelAntibitic}</label>
                                                        </Col>
                                                        <Col sm="10" className='p-l-0' >
                                                            <Input
                                                                disabled={microBacteriums.validated_at !== "" ? true : false}
                                                                type='text'
                                                                name="text"
                                                                className='form-control form-control-sm input-air-primary border-success input-mic'
                                                                value={_text?.text}
                                                                onChange={(e) => handleChangeBacteriumTexts(e, microBacteriums?.id_temp, idExam, _text?.text, microBacteriums?.id_mic_bacterium, "text", _text?.id)}
                                                            /> <br />
                                                        </Col>
                                                        <Col sm="1" className={microBacteriums.validated_at !== "" ? "d-none" : ""}  >
                                                            <i onClick={() => handleChangeComments(2, microBacteriums?.id_temp, idExam, microBacteriums?.id_mic_bacterium)} style={{ color: "#28a745" }} className={_k === 0 ? "fa fa-plus-circle f-28 pointer" : "d-none"}></i>
                                                            <i onClick={() => removeBacteriumAntibitic(idExam, _text?.id, microBacteriums?.id_mic_bacterium, microBacteriums?.id_temp)} className="fa fa-trash-o text-danger f-26 pointer"></i>
                                                        </Col>
                                                    </Row>
                                                )
                                            })

                                        }
                                    </div>
                                }
                            </Col>
                        </Row>
                    </div>
                )}
            </Col>
        </>
    )
}
